import { geocodeByPlaceId } from "react-google-places-autocomplete";

const getComponent = (components, type, useLong = true) => {
  const found = components.find((c) => c.types.includes(type));
  return found ? (useLong ? found.long_name : found.short_name) : "";
};

const buildFallbackAddress = (description = "") => ({
  formattedAddress: description,
  street: "",
  streetNumber: "",
  streetWithNumber: "",
  city: "",
  state: "",
  country: "",
  countryCode: "",
  postalCode: "",
});

export const parseGooglePlace = async (place) => {
  const { place_id, description } = place;

  try {
    const results = await geocodeByPlaceId(place_id);
    const result = results[0];

    if (!result) {
      return buildFallbackAddress(description);
    }

    const components = result.address_components;

    return {
      formattedAddress: result.formatted_address,
      street: getComponent(components, "route"),
      streetNumber: getComponent(components, "street_number"),
      streetWithNumber:
        `${getComponent(components, "route")} ${getComponent(components, "street_number")}`.trim(),
      city: getComponent(components, "locality"),
      state: getComponent(components, "administrative_area_level_1"),
      country: getComponent(components, "country"),
      countryCode: getComponent(components, "country", false),
      postalCode: getComponent(components, "postal_code"),
    };
  } catch (err) {
    console.error("Error fetching address details:", err);
    return buildFallbackAddress(description);
  }
};
